// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 12px;
  color: ${({ theme }) => theme.colors.shades[4]};
  line-height: 17px;
  text-align: center;

  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    font-size: 11px;
    line-height: 16px;
  }

  > small {
    font-size: inherit;

    > a {
      display: inline-block;
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.link.default};
    }
  }
`;

const FooterCopyright = ({ data }) => (
  data ? (
    // eslint-disable-next-line react/no-danger
    <Wrapper dangerouslySetInnerHTML={{ __html: data }} />
  ) : null
);

FooterCopyright.propTypes = {
  data: PropTypes.string
};

FooterCopyright.defaultProps = {
  data: undefined
};

/** @component */
export default FooterCopyright;
